import React from 'react'

function Blank() {
  return (
    <div style={{height:'150px'}}></div>
  )
}

export default Blank